import { put, call, takeEvery, select } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import customerAPI from '../../api/customer';
import { Creators as AppCreators } from '../../reducers/app';
import { Creators as CheckoutCreators } from '../../reducers/checkout';
import { Types, Creators } from '../../reducers/customer';
import { getUserInfo } from '../../utils/cookiesUser';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

const MESSAGES = {
  delete: 'Endereço excluído com sucesso',
  put: 'Endereço alterado com sucesso',
  post: 'Endereço salvo com sucesso',
};

function* customerAddressRequest({ payload, remove }) {
  try {
    const token = yield select(getToken);
    const { customer, app } = yield select(getState);

    const siteId = app.getIn(['config', 'siteId']);
    const { id } = getUserInfo();
    const { pathname } = app;

    const validPayload = payload;
    const customerId = customer.id || id;

    let method = 'get';

    if (validPayload) {
      method = validPayload.id ? 'put' : 'post';
    }

    if (remove) {
      method = 'delete';
    }

    let data = yield call(customerAPI.addresses[method], customerId, token, validPayload, siteId);

    if (method === 'post') {
      validPayload.id = data.id;
    }

    if (method !== 'get') {
      data = yield call(customerAPI.addresses.get, customerId, token, null, siteId);
    }

    if (pathname.includes('checkout') && method === 'post') {
      yield put(CheckoutCreators.checkoutAddressRequest(validPayload));
      yield put(CheckoutCreators.checkoutRequest(null, true));
    }

    yield put(Creators.customerAddressSuccess(data));
    yield put(AppCreators.modalRequest({ open: false }));

    if (method !== 'get') {
      yield put(AppCreators.feedbackRequest({ open: true, message: MESSAGES[method], type: 'success' }));
    }
  } catch (error) {
    const formatedErrror = formatError(error);
    yield put(Creators.customerAddressFailed(formatedErrror));
    yield put(AppCreators.feedbackRequest({ open: true, message: formatedErrror.message }));
  }
}

export default function* watch() {
  yield takeEvery(Types.CUSTOMER_ADDRESS_REQUEST, customerAddressRequest);
}
